(() => {
  if (window.garrnishGalleryLoading) return;
  window.garrnishGalleryLoading = true;
  const galleries = new Map();
  const load = (image) => {
    if (!image?.dataset.gallerySrc) return;
    if (!image.sizes.startsWith('auto')) image.sizes = `auto, ${image.sizes || '100vw'}`;
    image.loading = 'lazy';
    if (image.dataset.gallerySrcset) image.srcset = image.dataset.gallerySrcset;
    image.src = image.dataset.gallerySrc;
    delete image.dataset.gallerySrc;
    delete image.dataset.gallerySrcset;
  };
  function setup(root) {
    root.querySelectorAll('[data-deferred-gallery]').forEach((gallery) => {
      if (galleries.has(gallery)) return;
      const images = [...gallery.querySelectorAll('img[data-gallery-src]')];
      if (!('IntersectionObserver' in window)) {
        images.forEach(load);
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          load(entry.target);
          const slide = entry.target.closest('[data-swiper-slide]');
          load(slide?.nextElementSibling?.querySelector('img[data-gallery-src]'));
        });
      }, { rootMargin: '300px 0px', threshold: 0 });
      images.forEach((image) => observer.observe(image));
      galleries.set(gallery, observer);
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [gallery, observer] of galleries) {
      if (!event.target.contains(gallery)) continue;
      observer.disconnect();
      galleries.delete(gallery);
    }
  });
})();
